import { Info, XCircle } from "lucide-react";
import type { ReadinessMissing } from "@/lib/api/work-items";

export interface MissingItemsListProps {
  items: ReadinessMissing[];
  testId?: string;
}

/**
 * The readiness rules an ADO item does not meet, critical first as the API
 * orders them. Used by the Formulator (PI-SPEC-SW-1364) before the first
 * question in improve mode, in the projected readiness of the diff view, and
 * after submit when the item is still not ready.
 */
export function MissingItemsList({ items, testId }: MissingItemsListProps) {
  return (
    <ul className="space-y-2" data-testid={testId}>
      {items.map((m) => (
        <li key={m.id} className="flex items-start gap-2 text-sm" data-missing-id={m.id}>
          {m.severity === "critical" ? (
            <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-label="Required" />
          ) : (
            <Info className="mt-0.5 h-4 w-4 shrink-0 text-yellow-400" aria-label="Advisory" />
          )}
          <span>
            <span className="font-medium">{m.label}.</span>{" "}
            <span className="text-muted-foreground">{m.missingMessage}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
